import { Component, EventEmitter, Input, Output, ViewEncapsulation, ElementRef } from '@angular/core';
import { TrAccordion } from './tr-accordion.component';

@Component({
    moduleId: 'accordion',
    selector: 'tr-accordion-tab',
    templateUrl: `./tr-accordion-tab.html`,
    styleUrls: ['tr-accordion.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'TrAccordionTab',
    host: {
        role: 'accordion-tab',
    },
})
export class TrAccordionTab {

    public isDisabled: boolean = false;

    @Input() public icon: string = 'icon_expand_more';
    @Input() public closeOnlyOnIcon: boolean = false;
    @Input() public readOnly: boolean;

    @Input() public get animateInClass(): string {
        return this.getSize() + '-animate--in' + ' tr-accordion--content tr-accordion--expanded';
    }

    @Input() public get animateOutClass(): string {
        return this.getSize() + '-animate--out' + ' tr-accordion--content tr-accordion--collapsed';
    }

    @Input()
    get disabled(): boolean { return this.isDisabled; }
    set disabled(value) { this.isDisabled = value ? true : false; }

    @Input()
    get active(): boolean { return this.isActive; }
    set active(value) {
        this.isActive = value ? true : false;
        if (this.isActive && !this.parentAccordion.allowMultiples) {
            for (const tab of this.parentAccordion.tabs) {
                setTimeout(() => {
                    this.openTab.emit({ event });
                    this.parentAccordion.open.emit({ originalEvent: event });
                }, 300);
                if (tab !== this) {
                    tab.active = false;
                }
            }
        }
    }

    @Output() public closeTab: EventEmitter<any> = new EventEmitter<any>();
    @Output() public openTab: EventEmitter<any> = new EventEmitter<any>();
    @Output() public isTabActive: EventEmitter<any> = new EventEmitter<any>();

    private isActive: boolean = false;

    constructor(private parentAccordion: TrAccordion, public element: ElementRef) {
      this.parentAccordion.addTab(this);
    }

    public getSize() {
        return this.parentAccordion.size;
    }

    public clicked(event: Event, origin: string = 'header') {

        event.stopPropagation();
        event.preventDefault();

        if (this.isDisabled || this.readOnly) return;

        const index = this.findTabIndex();

        if (this.isActive) {

            if (this.parentAccordion.minActiveTabs !== 0) {
                if (this.getActiveTabsCount() <= this.parentAccordion.minActiveTabs) return;
            }
            if (this.closeOnlyOnIcon) {
                if (origin === 'icon') {
                    this.active = !this.isActive;
                }
            } else {
                this.active = !this.isActive;
            }

        } else if (!this.parentAccordion.allowMultiples) {
            for (const tab of this.parentAccordion.tabs) {
                tab.active = false;
            }
            this.isActive = true;
            this.openTab.emit({ event, index });
            this.parentAccordion.open.emit({ originalEvent: event, index });

        } else {
            this.isActive = true;
            this.openTab.emit({ event, index });
            this.parentAccordion.open.emit({ originalEvent: event, index });
        }

        this.isTabActive.emit({isTabActive: this.isActive, index });
    }

    public findTabIndex() {
        let index = -1;
        for (let i = 0; i < this.parentAccordion.tabs.length; i++) {
            if (this.parentAccordion.tabs[i] === this) {
                index = i;
                break;
            }
        }
        return index;
    }

    /**
     * Verifica a quantidade de tabs abertas
     */
    public getActiveTabsCount(): number {
        let count = 0;
        for (const tab of this.parentAccordion.tabs) {
            if (tab.isActive) count++;
        }

        return count;
    }
}
